import { render } from "./collaborativeSpecimenForm.vue?vue&type=template&id=35d8f636"
import script from "./collaborativeSpecimenForm.vue?vue&type=script&lang=js"
export * from "./collaborativeSpecimenForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__